import React, {PropTypes, Component} from 'react'
// service
import api from '../../../apiClient/v1.js'
import serviceStock from '../services/stockService.js'
// components
import { Header } from '../components/Header.jsx'
import { PendingStores } from '../components/PendingStores.jsx' 
import { ResultUpdate } from '../components/ResultUpdate.jsx'
import { SelectClient} from '../components/SelectClient.jsx'
import ReactNotify from 'react-notify'
import Modal from 'react-bootstrap/lib/Modal.js'
import * as ReactNotifyCSS from '../../../shared/ReactNotify/ReactNotify.css'

export class StockStores extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: '',
            resultado: [],
            storesPending: [],
            idClient: this.props.clients[0].idCliente,
            realizandoPeticion: false,
            showModalPasteStock: false,
            showResultUpdate: false,
            showPendingStores: true
        };
        
        this.cancelModalPasteStock = () => {
            this.setState({showModalPasteStock: false})
        };
        
        this.showModalPasteStock = () => {
            this.setState({showModalPasteStock: true})
        };
        
        this.onPasteData = (evt) => {
            this.setState({
                resultado: [],
                realizandoPeticion: true
            })
            evt.preventDefault()
            evt.clipboardData.items[0].getAsString(texto=> {
                let rows_texto = texto.trim().split('\n')
                rows_texto = rows_texto.filter(row=>row !== '')

                let rows_array = rows_texto.map(row => {
                    let _row = row.trim().split('\t')
                    if (_row.length < 2) return null
                    return {
                        'numero': _row[0],
                        'stock': _row[1].replace('.', '')
                    }
                }).filter(row => row != null)

                this.sendStock(rows_array)
            })
        };
        
        this.sendStock = (data) => {
            api.local.enviarPegarStock(this.state.idClient, data)
                .then(datos=> {
                    this.setState({
                        realizandoPeticion: false,
                        resultado: datos,
                        error: ''
                    })
                    this.cancelModalPasteStock()
                    this.showResultUpdate()
                    this.fetchPendingStores()
                })
                .catch(err=> {
                    let data = err.data
                    let mensajeError = data.error ? data.error : "Ocurrio un error al cargar el archivo"
                    this.setState({
                        realizandoPeticion: false,
                        error: mensajeError
                    })
                    this.refs.notificator.error("Error", mensajeError, 4 * 1000);
                })
        };
        
        this.showResultUpdate = () => {
            this.setState({
                showResultUpdate: true,
                showPendingStores: false
            })
        };
        
        this.showPendingStores = () => {
            this.setState({
                showResultUpdate: false,
                showPendingStores: true
            })
        };
        
        this.fetchPendingStores = () => {
            serviceStock.stock.pendingStores(this.state.idClient)
                .then(storesPending => {
                    this.setState({storesPending})
                })
                .catch(error=>console.log(error))
        };
        
        this.onSelectClientChanged = (idClient) => {
            this.setState({idClient : idClient}, () => this.fetchPendingStores())
        };
    }  
    
    componentDidMount(){
        this.fetchPendingStores();
    }
    
    render(){
        const { realizandoPeticion, showModalPasteStock, showResultUpdate, showPendingStores, storesPending, resultado} = this.state
        return (
            <div className="container-fluid">
                <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                <ModalPasteStock
                    onProcess={realizandoPeticion}
                    showModal={showModalPasteStock}
                    cancelModal={this.cancelModalPasteStock}
                    onPasteData={this.onPasteData}
                />
                <Header
                    clients = {this.props.clients}
                    showModalPasteStock={this.showModalPasteStock}
                    showResultUpdate={this.showResultUpdate}
                    showPendingStores={this.showPendingStores}
                    isShowResultUpdate={showResultUpdate}
                    isShowPendingStores={showPendingStores}
                />
                {this.props.canShowSelect ?
                    <div className="row">
                        <SelectClient
                            clients = {this.props.clients}
                            onSelectClientChanged = {this.onSelectClientChanged}
                        />
                    </div> 
                    : 
                    null
                }
                
                {showPendingStores ?
                    <PendingStores storesPending={storesPending}/> : null
                }
                {showResultUpdate ?
                    <ResultUpdate result={resultado}/> : null
                }
            </div>
        )
    }
}

StockStores.propTypes = {
    clients: PropTypes.array.isRequired,
    canShowSelect: PropTypes.bool.isRequired
    
}

const ModalPasteStock = ({ showModal, cancelModal, onPasteData, onProcess }) => (
    <Modal show={showModal} onHide={cancelModal}>
        <Modal.Header closeButton>
            <Modal.Title>Pegar stock de locales</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <h4>Copia la columna correspondiente a <b>número local</b> y <b>stock</b> de su planilla excel y pégalos en el siguiente recuadro.</h4>
            <br/>
            <input
                type="text"
                className="form-control"
                placeholder="Pega aquí número local y stock"
                onPaste={onPasteData}
                onKeyDown={evt => {if( !(evt.ctrlKey && evt.keyCode==86) ) evt.preventDefault()}}
                disabled={onProcess}
            />
            {onProcess? <h6>Favor espere, el Pop up desaparecerá automáticamente cuando termine el proceso.</h6> : null}
        </Modal.Body>
    </Modal>
)


// WEBPACK FOOTER //
// ./frontEnd/admin/stockStoreUpdate/containers/StockStores.jsx